import React from 'react';

function CopyToast({ visible, message }) {
  if (!visible) return null;
  return (
    <div className="toast" role="status" aria-live="polite">
      <span className="toast__icon" aria-hidden="true">✓</span>
      {message}
    </div>
  );
}

export default CopyToast;
